import { render } from "./VendorSearch.vue?vue&type=template&id=524bae3a"
import script from "./VendorSearch.vue?vue&type=script&lang=js"
export * from "./VendorSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__